import React from "react";

const Contact = () => {
  return (
    <div className="contact" id="contact">
      <div className="contact-background">
        <div>
          <h1>Have Any Project In Mind?</h1>
          <p>
            I am available to work on your projects and bring your ideas to
            life. I am just a click away.
          </p>
        </div>
        <a href="mailto:cynthiaezinne1@gmail.com">
          <button className="button-white">Send Me a Mail</button>
        </a>
      </div>
    </div>
  );
};

export default Contact;
